// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.employee-form__row__item.position-salary .c-input-wrapper{\n  min-height: 35px !important;\n}\n", ""]);
// Exports
module.exports = exports;
